import { Flex, Table, Group, ActionIcon } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconEdit, IconTrash } from "@tabler/icons-react";
import { YesNoDialog } from "components/YesNoDialog";
import { useState } from "react";
import { useAppTranslation } from "../../hooks/useTranslation";

interface VenuesListProps {
  venues: any[];
  onVenueChosen: (uid: string) => void;
  onVenueDelete: (uid: string) => void;
}

export const VenuesList = (props: VenuesListProps) => {
  const { venues, onVenueChosen, onVenueDelete } = props;
  const { t } = useAppTranslation();

  const [opened, { open, close }] = useDisclosure(false);
  const [deletedUid, setDeletedUid] = useState("");

  const deleteVenueDialog = (uid: string) => {
    setDeletedUid(uid);
    open();
  };

  const deleteVenue = () => {
    onVenueDelete(deletedUid);
  };

  return (
    <>
      <Flex direction="column" justify="space-between">
        <Table
          horizontalSpacing="md"
          verticalSpacing="xs"
          miw={700}
          highlightOnHover
          layout="fixed"
        >
          <Table.Thead>
            <Table.Tr>
              <Table.Th>{t("venues.name")}</Table.Th>
              <Table.Th>{t("venues.address")}</Table.Th>
              <Table.Th>{t("venues.city")}</Table.Th>
              <Table.Th>{t("venues.phone")}</Table.Th>
              <Table.Th>{t("venues.website")}</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {venues.map((venue) => {
              const onVenueClicked = () => {
                onVenueChosen(venue.uid);
              };
              return (
                <Table.Tr key={venue.uid}>
                  <Table.Td onClick={onVenueClicked}>{venue.name}</Table.Td>
                  <Table.Td onClick={onVenueClicked}>{venue.address}</Table.Td>
                  <Table.Td onClick={onVenueClicked}>{venue.city}</Table.Td>
                  <Table.Td onClick={onVenueClicked}>{venue.phone}</Table.Td>
                  <Table.Td onClick={onVenueClicked}>{venue.website}</Table.Td>
                  <Table.Td>
                    <Group>
                      <ActionIcon onClick={onVenueClicked}>
                        <IconEdit />
                      </ActionIcon>
                      <ActionIcon
                        style={{ zIndex: 10 }}
                        onClick={() => {
                          deleteVenueDialog(venue.uid);
                        }}
                      >
                        <IconTrash />
                      </ActionIcon>
                    </Group>
                  </Table.Td>
                </Table.Tr>
              );
            })}
          </Table.Tbody>
        </Table>
      </Flex>
      <YesNoDialog
        opened={opened}
        title={t("common.delete") + " " + t("venues.title").slice(0, -1)}
        question={t("venues.delete_confirmation")}
        onClose={close}
        onYes={deleteVenue}
      />
    </>
  );
};
